<template>
  <div style="padding: 20px 100px">
    <div class="style1">不折不扣落实中小企业财税支持政策</div>

    <div class="style2">人民网  2023-08-27 06:16</div>

    <div class="style4">
      本报北京8月26日电 (记者曲哲涵)一段时间以来，一系列支持中小企业发展的财税政策出台，
      财政部近日下发《关于加强财税支持政策落实 促进中小企业高质量发展的通知》(以下简称《通知》)，
      要求各地不折不扣将政策落实落细，为推动中小企业高质量发展提供有力保障。
    </div>

    <div class="style4">
      减税降费方面，在认真落实普惠性减税降费政策的基础上，全面落实对小微企业的精准税费优惠政策，
      不得以任何理由削弱政策力度。
    </div>

    <div class="style4">坚决防止征收过头税费，各地区要及时公布政府性基金和行政事业性收费目录，
      在目录以外不得擅自增加收费项目、扩大征收范围、提高征收标准。严禁乱收费、乱罚款、乱摊派。
    </div>

    <div class="style4">
      财政金融政策协同方面，《通知》要求落实创业担保贷款贴息政策，发挥政府性融资担保机构作用。
      发挥财政资金引导作用方面，
    </div>

    <div class="style4">
      《通知》明确，中央财政继续通过中小企业发展专项资金支持国家级专精特新“小巨人”企业发展。
      落实政府采购、稳岗就业等扶持政策方面，
    </div>

    <div class="style4">
      《通知》明确将进一步扩大中小企业采购份额。
      超过400万元的工程采购项目中适宜由中小企业提供的，预留份额由30%以上阶段性提高至40%以上的政策延续至2025年底。
      中小微企业招用符合条件的毕业年度或离校两年内未就业高校毕业生、登记失业青年，签订一年以上劳动合同的，
      可按规定申请一次性吸纳就业补贴。
    </div>

    <div class="style4">
      《通知》强调，在分配财政资金的过程中，对各类企业要一视同仁、平等对待。依法保障中小企业平等参与政府采购活动，
      进一步提升政府采购透明度。鼓励有条件的地区结合财力状况，聚焦当地中小企业发展面临的突出问题和薄弱环节，
      进一步加大财政政策扶持力度，缓解中小企业的经营压力和实际困难。
    </div>

  </div>

</template>

<script>
export default {
  mounted () {
    // 跳转后返回页面顶部
    window.scrollTo(0, 0)
  }
}
</script>

<style>
.style1{
  font-size: 20px;
  font-weight: 600;
  line-height: 80px;
}
.style2{
  font-size: 16px;
  line-height: 30px;
}
.style3{
  font-size: 16px;
  line-height: 30px;
}
.style4{
  font-size: 17px;
  line-height: 28px;
  margin: 20px 0;
}
.style5{
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  line-height: 30px;
  margin: 25px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/msg2.vue